var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("图标组件")]),
      _c("d2-icon", { staticClass: "d2-mr-10" }),
      _c("d2-icon", { staticClass: "d2-mr-10", attrs: { name: "github" } }),
      _c("d2-icon", {
        staticClass: "d2-mr-10",
        staticStyle: { "font-size": "100px" },
        attrs: { name: "github" }
      }),
      _c("d2-icon", { staticClass: "icon-demo", attrs: { name: "github" } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }